import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Web3 from "web3";
import axios from "axios";
import "./WalletTreasury.css";
const tokens = [
  {
    logo: "logo",
    contractAddress: "0x692AC1e363ae34b6B489148152b12e2785a3d8d6",
    name: "Polytrade",
    symbol: "TRADE",
    tokenBalance: 18,
    balance: 0,
  },
  {
    logo: "logo",
    contractAddress: "0x0000000000000000000000000000000000000000",
    name: "Polygon",
    symbol: "POL",
    tokenBalance: 18,
    balance: 0,
  },
];
const PolygonCondoTreasury = () => {
  const navigate = useNavigate();

  const goBack = (e) => {
    e.preventDefault();
    navigate(-1);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const condoPolygonTreasury = "0x4bF52ff02cc24ecD3d0e8E104f178647893Bd310";
  const url =
    "https://polygon-mainnet.g.alchemy.com/v2/AVp50h8nie8CF4LhvSjATb8_zEi3TLIE";

  const [tableData, setTableData] = useState(tokens);
  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const web3 = new Web3(new Web3.providers.HttpProvider(url));

        const getBalance = async () => {
          const weiBalance = await web3.eth.getBalance(condoPolygonTreasury);
          return web3.utils.fromWei(weiBalance, "ether");
        };
        const getAllBalance = async () => {
          const resp = await axios.post(url, {
            id: 43,
            jsonrpc: "2.0",
            method: "alchemy_getTokenBalances",
            params: [
              "0x4bF52ff02cc24ecD3d0e8E104f178647893Bd310",
              ["0x692AC1e363ae34b6B489148152b12e2785a3d8d6"],
            ],
          });
          return resp.data.result;
        };

        const getMetaForWETH = async () => {
          const resp = await axios.post(url, {
            id: 44,
            jsonrpc: "2.0",
            method: "alchemy_getTokenMetadata",
            params: ["0x692AC1e363ae34b6B489148152b12e2785a3d8d6"],
          });
          return resp.data;
        };

        const getMetaForUSDC = async () => {
          const resp = await axios.post(url, {
            id: 44,
            jsonrpc: "2.0",
            method: "alchemy_getTokenMetadata",
            params: ["0x3c499c542cef5e3811e1192ce70d8cc03d5c3359"],
          });
          return resp.data;
        };

        const [balance, allBalance, metaWETH, metaUSDC] = await Promise.all([
          getBalance(),
          getAllBalance(),
          getMetaForWETH(),
          getMetaForUSDC(),
        ]);

        let data = [...tableData];

        data[0].balance = parseFloat(
          web3.utils.fromWei(allBalance.tokenBalances[0].tokenBalance, "ether")
        );
        // console.log("---------------", data[0].balance);

        // data[1].balance = parseFloat(
        //   web3.utils.fromWei(allBalance.tokenBalances[1].tokenBalance, "ether")
        // );
        // data[1].logo = metaWETH.result.logo;
        // data[1].tokenBalance = metaWETH.result.decimals;
        // data[1].name = metaWETH.result.name;
        // data[1].symbol = metaWETH.result.symbol;

        // data[2].balance = parseFloat(
        //   web3.utils.fromWei(allBalance.tokenBalances[1].tokenBalance, "ether")
        // );
        // data[2].logo = metaUSDC.result.logo;
        // data[2].tokenBalance = metaUSDC.result.decimals;
        // data[2].name = metaUSDC.result.name;
        // data[2].symbol = metaUSDC.result.symbol;

        setTableData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchAllData();
  }, []);
  // console.log("TableDATAAAAAAAAAA", tableData);
  return (
    <div className="container poetsen-one-regular">
      <div className="go-back-link mt-3">
        <a href="/" onClick={goBack}>
          <i className="fa fa-arrow-left"></i> Go Back
        </a>
      </div>
      <div className="wallet-box">
        <p>
          Network: <span> polygon-mainnet</span>
        </p>
        <p>
          Wallet Address:
          <a
            style={{ textDecoration: "none" }}
            href="https://polygonscan.com/address/0x4bF52ff02cc24ecD3d0e8E104f178647893Bd310"
            target="__blank"
          >
            {`${condoPolygonTreasury.slice(
              0,
              6
            )}....${condoPolygonTreasury.slice(-6)}`}{" "}
            <i className="fa fa-share fa-sm"></i>
          </a>
        </p>
        <div className="table-responsive">
          <table className="table custom-table">
            <thead>
              <tr>
                <th>Logo</th>
                <th>Contract Address</th>
                <th>Name</th>
                <th>Symbol</th>
                <th>Token Balance</th>
                <th>Balance</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((token, index) => (
                <tr key={index}>
                  <td>
                    {token.logo ? (
                      <img src={token.logo} alt="Logo" width="20" height="20" />
                    ) : (
                      "No logo"
                    )}
                  </td>
                  <td>{token.contractAddress}</td>
                  <td>{token.name}</td>
                  <td>{token.symbol}</td>
                  <td>{token.tokenBalance}</td>
                  <td>{token.balance?.toFixed(6)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PolygonCondoTreasury;
